import React, {useState} from "react";
import "./Footer.css";
import { Link, useLocation } from "react-router-dom";
import Draggable from "react-draggable";
import ReactMarkdown from "markdown-to-jsx";
import { Link as LinkScroll } from "react-scroll";
// constants
import { SUCCESS_STORIES_ROUTE, CONTACT_US_ROUTE, ABOUT_US_ROUTE, PRICING_ROUTE, PROFILES_ROUTE, FAQS_STUDENTS_ROUTE, FAQS_PROFESSIONAL_ROUTE, HOW_IT_WORKS_PROFESSIONALS_ROUTE, HOW_IT_WORKS_STUDENTS_ROUTE, TERMS_AND_CONDITIONS_ROUTE, PRIVACY_POLICY_ROUTE } from "../../constants/routes";
import { CONTACT_EM_URL, CONTACT_FB_URL, CONTACT_IN_URL, CONTACT_WB_URL } from "../../constants/urls";
import { LOGO_SVG } from "../../constants/images";
// data
import content from "./data/footerDialog";
// mui
import { Typography, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Paper, PaperProps } from "@mui/material";

function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function MarkdownListItem(props) {
  return <Box component="li" sx={{ mt: 1, typography: "body1" }} {...props} />;
}

const options = {
  overrides: {
    h1: {
      component: Typography,
      props: {
        gutterBottom: true,
        variant: "h4",
        component: "h1",
      },
    },
    h2: {
      component: Typography,
      props: { gutterBottom: true, variant: "h6", component: "h2" },
    },
    h3: {
      component: Typography,
      props: { gutterBottom: true, variant: "subtitle1" },
    },
    h4: {
      component: Typography,
      props: {
        gutterBottom: true,
        variant: "caption",
        paragraph: true,
      },
    },
    p: {
      component: Typography,
      props: { paragraph: true },
    },
    a: { component: Link },
    li: {
      component: MarkdownListItem,
    },
  },
};

const Footer = () => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const [dialogState, setDialogState] = useState("");
  return (
    <footer className="site-footer">
      <Dialog
        open={Boolean(dialogState)}
        onClose={() => setDialogState("")}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        {dialogState ? (
          <>
            <DialogTitle
              style={{ cursor: "move", fontWeight: "600", color: "#666666" }}
              id="draggable-dialog-title"
            >
              {dialogState}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <ReactMarkdown options={options} className="markdown">
                  {content[dialogState]}
                </ReactMarkdown>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                autoFocus
                style={{ textTransform: "none" }}
                onClick={() => setDialogState("")}
              >
                Got It
              </Button>
            </DialogActions>
          </>
        ) : null}
      </Dialog>
      <div className="container">
        <div className="row">
          <h4 style={{ color: "white" }}>interwiu.com by</h4>
          <div
            className="footer__logo"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <img
              src={LOGO_SVG}
              style={{
                borderRadius: "50%",
                width: "55px",
                height: "55px",
                marginRight: "10px",
                backgroundColor: "white",
              }}
              alt=""
            />
            <div>
              <h3 style={{ color: "#02A3E8" }}>
                Fyzen Career Solutions Pvt Ltd
              </h3>
              <p
                className="text-justify"
                style={{ color: "white", fontSize: "18px", marginBottom: "0" }}
              >
                a Career Management Tech Start-up by Alumni of IIT Madras
              </p>
            </div>
          </div>
          <hr />
          <div className="col-sm-12 col-md-3">
            <h6>Company</h6>
            <ul className="footer-links">
              <li onClick={() => window.scrollTo(0, 0)}>
                {location.pathname === "/" ? (
                  <LinkScroll to="testimonials" spy={true} smooth={true}>
                    Success Stories
                  </LinkScroll>
                ) : (
                  <Link to={SUCCESS_STORIES_ROUTE}>Success Stories</Link>
                )}
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                <Link to={CONTACT_US_ROUTE}>Contact Us</Link>
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                <Link to={ABOUT_US_ROUTE}>About Us</Link>
              </li>
            </ul>
          </div>

          <div className="col-xs-6 col-md-3">
            <h6>Platform</h6>
            <ul className="footer-links">
              <li onClick={() => window.scrollTo(0, 0)}>
                {location.pathname === "/" ? (
                  <LinkScroll to="howItWorks" spy={true} smooth={true}>
                    How It Works?
                  </LinkScroll>
                ) : (
                  <Link
                    to={
                      user?.role === "Interviewer"
                        ? HOW_IT_WORKS_PROFESSIONALS_ROUTE
                        : HOW_IT_WORKS_STUDENTS_ROUTE
                    }
                  >
                    How It Works?
                  </Link>
                )}
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                {location.pathname === "/" ? (
                  <LinkScroll to="profiles" spy={true} smooth={true}>
                    Profiles
                  </LinkScroll>
                ) : (
                  <Link to={PROFILES_ROUTE}>Profiles</Link>
                )}
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                {location.pathname === "/" ? (
                  <LinkScroll to="pricing" spy={true} smooth={true}>
                    Pricing
                  </LinkScroll>
                ) : (
                  <Link to={PRICING_ROUTE}>Pricing</Link>
                )}
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                {location.pathname === "/" ? (
                  <LinkScroll to="faqs" spy={true} smooth={true}>
                    FAQs
                  </LinkScroll>
                ) : (
                  <Link
                    to={
                      user?.role === "Interviewer"
                        ? FAQS_PROFESSIONAL_ROUTE
                        : FAQS_STUDENTS_ROUTE
                    }
                  >
                    FAQs
                  </Link>
                )}
              </li>
            </ul>
          </div>

          <div className="col-xs-6 col-md-3">
            <h6>Legal</h6>
            <ul className="footer-links">
              <li>
                <a onClick={(e) => setDialogState(e.target.innerText)}>
                  Payment Policy
                </a>
              </li>
              <li>
                <a onClick={(e) => setDialogState(e.target.innerText)}>
                  Cancellation and Refund Policy
                </a>
              </li>
              <li>
                <Link to={TERMS_AND_CONDITIONS_ROUTE}>Terms and Conditions</Link>
              </li>
              <li>
                <Link to={PRIVACY_POLICY_ROUTE}>Privacy Policy</Link>
              </li>
            </ul>
          </div>

          <div className="col-xs-6 col-md-3">
            <h6>Info</h6>
            <ul className="footer-links">
              <li>
                <a onClick={(e) => setDialogState(e.target.innerText)}>
                  Why interwiu.com?
                </a>
              </li>
              <li>
                <a onClick={(e) => setDialogState(e.target.innerText)}>
                  Why Mock Interviews with Feedback?
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-sm-6 col-xs-12">
            <p className="copyright-text" style={{ color: "white" }}>
              Copyright &copy; 2022 All Rights Reserved by&nbsp;
              <a href={CONTACT_WB_URL} style={{ color: "#02A3E8" }}>
                Fyzen Career Solutions Pvt Ltd
              </a>
            </p>
          </div>

          <div className="col-md-4 col-sm-6 col-xs-12">
            <ul className="social-icons">
              {/* <li>
                <a
                  className="facebook"
                  href={CONTACT_FB_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-facebook"></i>
                </a>
              </li> */}
              <li>
                <a
                  className="linkedin"
                  href={CONTACT_IN_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a
                  className="envelope"
                  href={CONTACT_EM_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-envelope"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
